import { useCallback } from 'react';
import { resetAllPreservingDevicePreferences, useAppEnvConfig, useSocket } from '@connect-x-app/hybrid-state';
import { COOKIE_ACCESS_TOKEN_NAME, COOKIE_REFRESH_TOKEN_NAME } from '@connect-x-app/shared-utils';
import { useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { redirectTo } from '../utils/redirect';
import { useFirebaseConfig } from './useFirebaseConfig';

type LogoutOptions = { redirectToLogin?: boolean };

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { env } = useAppEnvConfig();
  const { deleteFirebaseToken, unregisterServiceWorker } = useFirebaseConfig();
  const { socket } = useSocket();

  return useCallback(
    async ({ redirectToLogin = false }: LogoutOptions = {}) => {
      Cookies.remove(COOKIE_ACCESS_TOKEN_NAME);
      Cookies.remove(COOKIE_REFRESH_TOKEN_NAME);
      socket?.disconnect();
      await queryClient.cancelQueries();
      queryClient.clear();
      sessionStorage.clear();
      resetAllPreservingDevicePreferences();
      unregisterServiceWorker();
      deleteFirebaseToken();
      let redirectUrl = env?.connectServiceApiHost ?? '';
      if (redirectToLogin) {
        redirectUrl += `${window.location.pathname}${window.location.search}`;
      }
      const origin = encodeURIComponent(redirectUrl);
      const idpPath = redirectToLogin ? 'idp/login' : 'idp/logout';
      redirectTo(`${env?.connectServiceApiHost}/${idpPath}?origin=${origin}`);
    },
    [socket, queryClient, unregisterServiceWorker, deleteFirebaseToken, env?.connectServiceApiHost],
  );
};
